"use strict";
// This is required because the Salient theme forces a low-resolution versions of images on mobile.
document.addEventListener("DOMContentLoaded", function forceHighResolutionHeaderImage() {
    const headerImage = document.querySelector(".page-header-bg-image");
    if (headerImage) {
        const headerBgImage = headerImage.style.backgroundImage;
        headerImage.style.setProperty("background-image", headerBgImage, "important");
    }
});
